import { useEffect } from "react";
import { SelectUOMProps } from "../../../pages/get-quote/models"
import styled from 'styled-components';

const SelectUOM = ({setDataFormik, freightInfoUOM, freightInfo, freightInfoTotals, disabled, readOnly, hazContact, setOpenHazContactModal, formik, setNewValuesWhenRateCleared, setOpenClearRateToEditModal}: SelectUOMProps) => {

    // Force UOM to US when readOnly is true and current value is METRIC
    // This handles the edge case where Shipping Location default UOM is Metric
    // but disableMetricDataEntry is enabled - should always show US
    useEffect(() => {
        if (readOnly && freightInfoUOM?.value === 'METRIC') {
            onChangeUOM('US', 'METRIC')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [readOnly, freightInfoUOM?.value])

    const onChangeUOM = (value, oldValue) => {
        setDataFormik('freightInfoUOM', {
            value: value,
            oldValue: oldValue,
        })

        if (value === 'US') {
            if (oldValue === 'METRIC') {
                // conversion to US from metric
                freightInfo.forEach((freight, index) => {
                    let { weight, L, H, W } = freight
                    let newInfoData = [...freightInfo]
                    newInfoData[index].weight = parseFloat((weight / 0.45359237).toFixed(2))
                    newInfoData[index].L = parseFloat((L / 2.54).toFixed(2))
                    newInfoData[index].H = parseFloat((H / 2.54).toFixed(2))
                    newInfoData[index].W = parseFloat((W / 2.54).toFixed(2))
                    setDataFormik('freightInfo', newInfoData)
                })
            } else if (oldValue === 'MIXED') {
                // conversion to US from Kgs / in
                freightInfo.forEach((freight, index) => {
                    let { weight } = freight
                    let newInfoData = [...freightInfo]
                    newInfoData[index].weight = parseFloat((weight / 0.45359237).toFixed(2))
                    setDataFormik('freightInfo', newInfoData)
                })
            } else {
                // no conversion Mantain US
            }
            setDataFormik('freightInfoTotals', {
                ...freightInfoTotals,
                symbol: 'lbs',
            })
        } else if (value === 'METRIC') {
            if (oldValue === 'US') {
                // conversion to Metric from US
                freightInfo.forEach((freight, index) => {
                    let { weight, L, H, W } = freight
                    let newInfoData = [...freightInfo]
                    newInfoData[index].weight = parseFloat((weight * 0.45359237).toFixed(2))
                    newInfoData[index].L = parseFloat((L * 2.54).toFixed(2))
                    newInfoData[index].H = parseFloat((H * 2.54).toFixed(2))
                    newInfoData[index].W = parseFloat((W * 2.54).toFixed(2))
                    setDataFormik('freightInfo', newInfoData)
                })

            } else if (oldValue === 'MIXED') {
                // conversion to Metric from Kgs / in
                freightInfo.forEach((freight, index) => {
                    let { L, H, W } = freight
                    let newInfoData = [...freightInfo]
                    newInfoData[index].L = parseFloat((L * 2.54).toFixed(2))
                    newInfoData[index].H = parseFloat((H * 2.54).toFixed(2))
                    newInfoData[index].W = parseFloat((W * 2.54).toFixed(2))
                    setDataFormik('freightInfo', newInfoData)
                })
            } else {
                // no conversion Mantain Metric
            }
            setDataFormik('freightInfoTotals', {
                ...freightInfoTotals,
                symbol: 'kgs',
            })
        } else {
            // Selected Kgs/ in
            if (oldValue === 'US') {
                // conversion to Kgs/in from US
                freightInfo.forEach((freight, index) => {
                    let { weight } = freight
                    let newInfoData = [...freightInfo]
                    newInfoData[index].weight = parseFloat((weight * 0.45359237).toFixed(2))
                    setDataFormik('freightInfo', newInfoData)
                })
            } else if (oldValue === 'METRIC') {
                // conversion to Kgs / in from METRIC
                freightInfo.forEach((freight, index) => {
                    let { L, H, W } = freight
                    let newInfoData = [...freightInfo]
                    newInfoData[index].L = parseFloat((L / 2.54).toFixed(2))
                    newInfoData[index].H = parseFloat((H / 2.54).toFixed(2))
                    newInfoData[index].W = parseFloat((W / 2.54).toFixed(2))
                    setDataFormik('freightInfo', newInfoData)
                })
            } else {
                // no conversion Mantain Kgs/in
            }
            setDataFormik('freightInfoTotals', {
                ...freightInfoTotals,
                symbol: 'kgs',
            })
        }
    }

    return (

        <SelectUOMWrapper className='mb-5 col-md-12 col-xl-5 p-3 select-uom-wrapper'>
            <div className="col-3 col-xl-2 d-flex justify-content-center justify-content-xl-end form-check form-check-custom form-check-solid form-check-sm">
                <div className="me-5">
                    UOM
                </div>
            </div>
            {(!readOnly || freightInfoUOM?.value === "US") && (
                <div className={`col-5 ${hazContact ? 'col-sm-3' : 'col-sm-5'} col-xl-2 form-check form-check-custom form-check-solid form-check-sm`} style={readOnly ? {pointerEvents: 'none'} : {}}>
                    <input
                        disabled={disabled}
                        className="form-check-input white-bg"
                        type="radio"
                        name="radioUOM"
                        value="US"
                        id="US"
                        onClick={() => {
                            if(readOnly) return;
                            if(formik?.values?.carrierInformation?.name){
                                setNewValuesWhenRateCleared({
                                    valuesFor: `freightInfoUOM`,
                                    originalValues: {
                                        value: 'METRIC',
                                        oldValue: ''
                                    },
                                    values: {
                                        value: 'US',
                                        oldValue: 'METRIC'
                                    },
                                    functionToDo: () => {onChangeUOM('US', freightInfoUOM?.value)}
                                })
                                setOpenClearRateToEditModal(true)
                            }
                        }}
                        onChange={(e) => {
                            if(readOnly) return;
                            if(!formik?.values?.carrierInformation?.name){
                                onChangeUOM(e.target.value, freightInfoUOM?.value)
                            }
                        }}
                        checked={freightInfoUOM?.value === "US"}
                    />
                    <label className="form-check-label" htmlFor="US" style={{cursor: 'default'}}>
                        lb/in
                    </label>
                </div>
            )}
            {(!readOnly || freightInfoUOM?.value === "METRIC") && (
                <div className={`col-4 ${hazContact ? 'col-sm-3' : 'col-sm-4'} col-xl-4 form-check form-check-custom form-check-solid form-check-sm`} style={readOnly ? {pointerEvents: 'none'} : {}}>
                    <input
                        disabled={disabled}
                        className="form-check-input white-bg"
                        type="radio"
                        name="radioUOM"
                        value="METRIC"
                        id="METRIC"
                        onClick={() => {
                            if(readOnly) return;
                            if(formik?.values?.carrierInformation?.name){
                                setNewValuesWhenRateCleared({
                                    valuesFor: `freightInfoUOM`,
                                    originalValues: {
                                        value: 'US',
                                        oldValue: ''
                                    },
                                    values: {
                                        value: 'METRIC',
                                        oldValue: 'US'
                                    },
                                    functionToDo: () => {onChangeUOM('METRIC', freightInfoUOM?.value)}
                                })
                                setOpenClearRateToEditModal(true)
                            }
                        }}
                        onChange={(e) => {
                            if(readOnly) return;
                            if(!formik?.values?.carrierInformation?.name){
                                onChangeUOM(e.target.value, freightInfoUOM?.value)
                            }
                        }}
                        checked={freightInfoUOM?.value === "METRIC"}
                    />
                    <label className="form-check-label" htmlFor="METRIC" style={{cursor: 'default'}}>
                        kg/cm
                    </label>
                </div>
            )}
            {
                hazContact ?
                <div className="col-12 col-sm-3 col-xl-4">
                    <button
                        className="btn btn-primary"
                        disabled={!freightInfo.map((f) => f.hazmat).includes(true)}
                        onClick={(e) => {
                            e.preventDefault()
                            setOpenHazContactModal(true)                            
                        }}
                    >
                        Haz. contact
                    </button>
                </div> : null
            }

        </SelectUOMWrapper>

    )
}

export default SelectUOM

export const SelectUOMWrapper = styled.div`
    display: flex;
    background-color: rgb(228,230,239);
    border-radius: 0.475rem;
`